import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { TExportTableWithWidget } from 'types/GlobalExportTable'
import { isExportTableWidget } from 'types/GlobalWidget'

// Select all export tables as array
export const selectAllExportTables = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.ExportTableStore.data
  ],
  (data) => Object.values(data)
)

// Select loading states
export const selectExportTablesLoading = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.ExportTableStore.fetched,
    (state: ApplicationState) => state.ExportTableStore.assignedApiKeys,
    (state: ApplicationState) => state.ExportTableStore.isCreating,
    (state: ApplicationState) => state.ExportTableStore.isDeleting,
    (state: ApplicationState) => state.ExportTableStore.isUpdating,
    (state: ApplicationState) => state.ExportTableStore.isFetchingOne
  ],
  (
    fetched,
    assigningApiKeys,
    isCreating,
    isDeleting,
    isUpdating,
    isFetchingOne
  ) => ({
    fetched,
    assigningApiKeys,
    isCreating,
    isDeleting,
    isUpdating,
    isFetchingOne
  })
)

// Select export table with resolved widget
export const selectExportTableIncludeWidget = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.ExportTableStore.data,
    (state: ApplicationState) => state.WidgetStore.widgets,
    (_: ApplicationState, id: string | null) => id
  ],
  (exportTables, widgets, id): TExportTableWithWidget | null => {
    if (!id) return null

    const exportTable = exportTables[id]

    if (!exportTable) return null

    // Get widget from WidgetStore
    const widget = widgets[exportTable.widget_id]

    if (!widget || !isExportTableWidget(widget)) {
      return { ...exportTable, widget: null }
    }

    return { ...exportTable, widget }
  }
)
